const loader = document.querySelector(".loader");
const page = document.querySelector(".hero-section");
document.onreadystatechange = function () {
    if (document.readyState === "complete") {
        setTimeout(function () {
            loader.outerHTML = "";
            page.style.display = "inherit"
        }, 2000)
    }
};